import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "ya-order-wrapper"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "ya-order-wrapper-item-icon"
};
var _hoisted_4 = {
  class: "ya-order-wrapper-item-icon-mark"
};
var _hoisted_5 = ["src"];
import constants from '@/constants';
import { isLoginAuthenticated } from '@/utils/common';
import { reactive, watch } from 'vue';
import { useRouter } from 'vue-router';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { YourAccount } from '@/assets/marketplaces/cn/configs';
import { useLess } from '@/models/hooks';
export default {
  __name: 'YAOrder',
  props: {
    isLogin: Boolean,
    toBeCommentedCount: Number
  },
  emits: ['update:isLogin'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    useLess('views/yourAccount/components/YAOrder.less');
    var router = useRouter();
    var orderCount = reactive({
      noShipmentCount: 0,
      deliveryingCount: 0,
      toBeCommentedCount: 0,
      afterSaleCount: 0,
      totalOrderCount: 0
    });
    var jumpToPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(routerName, status, key) {
        var isLoginStatus;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (YourAccount.CLICK_EVENTS_MAPPINGS[key]) {
                awsRumHandler.recordClickEvent(clickEvents.yourAccountPage[YourAccount.CLICK_EVENTS_MAPPINGS[key]]);
              }
              // status: 1-All Orders 2-To be shipped 3-To be received
              _context.next = 3;
              return isLoginAuthenticated();
            case 3:
              _context.next = 5;
              return isLoginAuthenticated(false);
            case 5:
              isLoginStatus = _context.sent;
              emit('update:isLogin', isLoginStatus);
              if (isLoginStatus) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return");
            case 9:
              if (routerName === 'asList') {
                router.push({
                  name: routerName
                });
              } else {
                router.push({
                  name: routerName,
                  params: {
                    status
                  }
                });
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function jumpToPage(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    watch(props, propsObj => {
      if (propsObj.isLogin) {
        if (propsObj.toBeCommentedCount) {
          orderCount.toBeCommentedCount = propsObj.toBeCommentedCount;
        }
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(constants).YA_ORDER_TABS, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: $event => jumpToPage(item.PATH, item.PARAMS, item.KEY),
          class: "ya-order-wrapper-item"
        }, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, " ... ", 512), [[_vShow, orderCount[item.KEY]]]), _createElementVNode("img", {
          src: item.ICON,
          draggable: "false"
        }, null, 8, _hoisted_5)]), _createElementVNode("span", null, _toDisplayString(item.NAME), 1)], 8, _hoisted_2);
      }), 128))])]);
    };
  }
};